<ws-modal-wrapper
    headerLabel="Save Report"
    [disableSave]="!report || !report.variantName || (report.categoryID === -1 && !newCategoryName)"
    [loading]="loading"
    (save)="save()"
    (cancel)="cancel()"
>
    @if (!loading && report) {
        <div class="mb-4">
            @if (!hasEditPermission) {
                <input type="hidden" [(ngModel)]="isSystemReport" [value]="false" />
            }
            @if (hasEditPermission && !isComplianceReport) {
                <div class="row mb-4 align-items-center">
                    <label class="col-md-2 control-label">Type:</label>
                    <div class="col-md-10">
                        <div class="radio" style="display: inline-block">
                            <label>
                                <input
                                    type="radio"
                                    [(ngModel)]="isSystemReport"
                                    [value]="false"
                                    (click)="reportTypeClicked()"
                                />
                                User Report
                            </label>
                        </div>
                        <div class="radio" style="display: inline-block; margin-left: 20px">
                            <label>
                                <input
                                    type="radio"
                                    [(ngModel)]="isSystemReport"
                                    [value]="true"
                                    (click)="reportTypeClicked()"
                                />
                                System Report
                            </label>
                        </div>
                    </div>
                </div>
            }
            @if (!isComplianceReport) {
                <div class="row mb-4 align-items-center">
                    <label class="col-md-2 control-label">Category:</label>
                    <div class="col-md-10">
                        <div class="input-group">
                            @if (isSystemReport) {
                                <select
                                    class="form-select form-select-sm w-auto flex-grow-0"
                                    [(ngModel)]="report.categoryID"
                                >
                                    @for (category of systemReportCategories; track category) {
                                        <option [ngValue]="category.categoryId">
                                            {{ category.categoryName }}
                                        </option>
                                    }
                                    <option [ngValue]="-1">(new category...)</option>
                                </select>
                            }
                            @if (!isSystemReport) {
                                <select
                                    class="form-select form-select-sm w-auto flex-grow-0"
                                    [(ngModel)]="report.categoryID"
                                >
                                    @for (category of userReportCategories; track category) {
                                        <option [ngValue]="category.categoryId">
                                            {{ category.categoryName }}
                                        </option>
                                    }
                                    <option [ngValue]="-1">(new category...)</option>
                                </select>
                            }
                            @if (report.categoryID === -1) {
                                <input
                                    type="text"
                                    class="form-control"
                                    [(ngModel)]="newCategoryName"
                                    style="margin: 5px 0"
                                    maxlength="100"
                                />
                            }
                        </div>
                    </div>
                </div>
            }
            <div class="row mb-4 align-items-center">
                <label class="col-md-2 control-label">Name:</label>
                <div class="col-md-10">
                    <span style="float: left; margin-top: 5px">{{ report.displayName }} - </span>
                    <input
                        type="text"
                        maxlength="50"
                        class="form-control"
                        style="float: left; margin-left: 1em; width: 285px"
                        [(ngModel)]="report.variantName"
                        #name="ngModel"
                    />
                    @if (name.errors?.['maxlength']) {
                        <span class="text-danger"> The maximum length for the name is 50 characters </span>
                    }
                </div>
            </div>
        </div>
    }
</ws-modal-wrapper>
